function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var _require = require('crypto'),
  timingSafeEqual = _require.timingSafeEqual; //Wtf is this???
var saito = require('../../lib/saito/saito');
var GameTemplate = require('../../lib/templates/gametemplate');
var WuziqiGameRulesTemplate = require('./lib/wuziqi-game-rules.template');
var WuziqiGameOptionsTemplate = require('./lib/wuziqi-game-options.template');
var WuziqiSingularGameOptionsTemplate = require('./lib/wuziqi-singular-game-options.template');
var htmlTemplate = require('./lib/game-html.template');
var Wuziqi = /*#__PURE__*/function (_GameTemplate) {
  function Wuziqi(app) {
    var _this;
    _classCallCheck(this, Wuziqi);
    _this = _callSuper(this, Wuziqi, [app]);

    // Define static game parameters and add global variables.

    _this.name = 'Wuziqi';
    _this.slug = 'wuziqi';
    _this.game_length = 10; //Estimated number of minutes to complete a game
    _this.description = 'Take turns placing black or white tiles on a Go board of various sizes to make a line of five in a row to win the round. Also known as 五子棋, Gokomu, or Gobang.';
    _this.categories = 'Games Boardgame Classic';
    _this.status = 'beta';
    _this["class"] = 'app';
    _this.minPlayers = 2;
    _this.maxPlayers = 2;
    _this.moves = [];
    _this.bestof = 1;
    _this.social.creator = 'Richard M Parris';
    _this.title = '五子棋 - Five-in-a-Row';
    _this.hud.is_draggable = 0;
    _this.can_play_async = 1;
    _this.insert_rankings = true;
    _this.clock.container = '#clock_';
    _this.roles = ['observer', 'black', 'white'];
    _this.acknowledge_text = 'next round...'; // not "i understand..."

    return _possibleConstructorReturn(_this, _this);
  }
  _inherits(Wuziqi, _GameTemplate);
  return _createClass(Wuziqi, [{
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app) {
        var hh, i, player, _i, _i2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (this.browser_active) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              if (!this.initialize_game_run) {
                _context.n = 2;
                break;
              }
              return _context.a(2, 0);
            case 2:
              _context.n = 3;
              return this.injectGameHTML(htmlTemplate());
            case 3:
              _context.n = 4;
              return _superPropGet(Wuziqi, "render", this, 3)([app]);
            case 4:
              this.menu.addMenuOption('game-game', 'Game');
              this.menu.addSubMenuOption('game-game', {
                text: 'How to Play',
                id: 'game-intro',
                "class": 'game-intro',
                callback: function callback(app, game_mod) {
                  game_mod.menu.hideSubMenus();
                  game_mod.overlay.showClosable(game_mod.returnGameRulesHTML());
                }
              });

              // Add Chat Features to Menu
              this.menu.addChatMenu(this.roles.slice(1));

              // Render menu and attach events
              this.menu.render();
              if (this.game.player > 0) {
                this.hud.render();
                hh = document.querySelector('.hud-header');
                if (hh) {
                  hh.classList.add(this.roles[this.game.player]);
                }
                document.querySelector('.main').classList.add(this.roles[this.game.player]);
              }
              this.racetrack.win = Math.ceil(this.game.options.best_of / 2);
              this.racetrack.title = 'Best of ' + this.game.options.best_of;
              this.racetrack.icon = "<i class=\"fa-solid fa-trophy\"></i>";
              this.racetrack.players = [];
              for (i = 0; i < this.game.players.length; i++) {
                player = {
                  name: this.app.keychain.returnUsername(this.game.players[i]) /*this.roles[i + 1].toUpperCase()*/,
                  score: this.game.score[i],
                  color: this.roles[i + 1]
                };
                this.racetrack.players.push(player);
              }
              this.racetrack.render();
              this.playerbox.render();
              for (_i = 1; _i <= this.game.players.length; _i++) {
                this.playerbox.updateIcons("<div class=\"tool-item item-detail turn-shape ".concat(this.roles[_i].toLowerCase(), "\"></div>"), _i);
                this.playerbox.updateBody("<div class=\"player_clock\" id=\"clock_".concat(_i, "\"></div>"), _i);
              }
              if (this.game.player == 1) {
                $('.game-playerbox-manager').addClass('reverse');
              }
              if (this.useClock == 1) {
                this.clock.render();
                for (_i2 = 0; _i2 < this.game.clock.length; _i2++) {
                  this.clock.displayTime(this.game.clock[_i2].limit - this.game.clock[_i2].spent, _i2 + 1);
                }
              }

              // Temporary fallback experiment -- if successful move to gametemplate
              if (this.game.turn.length) {
                this.sendGameMoveTransaction('game', {
                  target: this.returnNextPlayer()
                });
              }
            case 5:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function render(_x) {
        return _render.apply(this, arguments);
      }
      return render;
    }() //html for game intro/rules
  }, {
    key: "returnGameRulesHTML",
    value: function returnGameRulesHTML() {
      return WuziqiGameRulesTemplate(this.app, this);
    }
  }, {
    key: "initializeGame",
    value: function initializeGame(game_id) {
      if (this.game.initializing) {
        console.log('Initialize WuZiQi');
        // Initialize our game
        this.game.score = [0, 0];

        // Set the game board to the size set in the options
        this.game.size = this.game.options.board_size;
        this.generateBoard(this.game.options.board_size);

        // Send 'let's get started' message.
        this.game.queue.push('clearboard\t1');
        this.game.queue.push('READY');
      }
    }

    // Create the game board data structure
  }, {
    key: "generateBoard",
    value: function generateBoard(x) {
      //console.log("Generate board for " + x);
      // Set the board size (always a square of side length set by the user.)
      var cells = x * x;
      // Clear the board
      this.game.board = [];
      // Itterate through the cells in the board
      for (var n = 1; n <= cells; n++) {
        // Create an empty cell
        var cell = {};
        // Add the id
        cell.id = n;
        // The cell is blank.
        cell.owner = 'none';
        // The cell does not have a winning tile in it.
        cell.winner = false;

        /* Sets are the rows, columns and diagonals to which the cell belongs.
                 Each row, col, and diag has a unique index, so that adjacent sells share
                 a value in one of the four set categories
              */
        cell.sets = {};
        // Set the row as the total divided by the side length rounded up.
        cell.sets.row = Math.ceil(n / x);
        // Set the collumn as the cell id mod side length.
        cell.sets.col = (n - 1) % x + 1;
        // Set the left down diagonal as where inverse of the column summed with row is constant
        cell.sets.lddiag = x - cell.sets.col + cell.sets.row;
        // Set the right and up diagonal to where the sum of the row and collumn
        cell.sets.rudiag = cell.sets.row + cell.sets.col - 1;
        this.game.board.push(cell);
      }
      //console.log(this.game.board);
    }

    // UI Score Update
    /* Though unnecessary to loop through two players, it is important to remember that players are numbered (1, 2, 3), 
          but data structures for player properties are typically 0-indexed arrays
      */
  }, {
    key: "updateScore",
    value: function updateScore() {
      if (!this.gameBrowserActive()) {
        return;
      }
      var roundsToWin = Math.ceil(this.game.options.best_of / 2);
      for (var i = 0; i < this.game.players.length; i++) {
        var scoreHTML = "<div>Score: </div><div class=\"tokens\">";
        for (var j = 0; j < this.game.score[i]; j++) {
          scoreHTML += "<img class=\"piece\" src=\"img/".concat(this.roles[i + 1], "piece.png\">");
        }
        for (var _j = 0; _j < roundsToWin - this.game.score[i]; _j++) {
          scoreHTML += "<img class=\"piece opaque30\" src=\"img/".concat(this.roles[i + 1], "piece.png\">");
        }
        scoreHTML += '</div>';
      }
    }
  }, {
    key: "updateStatus",
    value: function updateStatus(str) {
      if (this.lock_interface == 1) {
        return;
      }
      this.game.status = str;
      if (this.gameBrowserActive()) {
        this.hud.updateStatus(str);
        this.hud.updateMenu([]);
        this.hud.updateCards([]);
      }
    }
  }, {
    key: "animatePlay",
    value: function animatePlay(cell) {
      //$(`div#tile_${cell.id} div`).removeClass("empty").addClass("piece").addClass(cell.owner).fadeIn();
      $("div#tile_".concat(cell.id, " div")).remove();
      $("<div class=\"piece ".concat(cell.owner, "\"></div>")).hide().appendTo("#tile_".concat(cell.id)).fadeIn(600);
    }

    // Iterate through the board object to draw each cell in the DOM
  }, {
    key: "drawBoard",
    value: function drawBoard(board) {
      var _this2 = this;
      if (!this.gameBrowserActive()) {
        console.log('Opt out of drawing board');
        return;
      }
      console.log('DRAWING BOARD!');
      //console.log(board);
      boardElement = document.querySelector('.board');
      // Clear the board
      boardElement.innerHTML = '';
      // Add the CSS grid-template-columns value to the correct number of rows.
      //Because variable board size, easier than hardcoding size classes in CSS
      boardElement.style.gridTemplate = "repeat(".concat(this.game.size, ", 1fr) / repeat(").concat(this.game.size, ", 1fr)"); //'repeat(' + this.game.size + ', 1fr)';

      // Draw the cells
      var ct = 1;
      board.forEach(function (cell) {
        var tile = document.createElement('div');
        tile.id = 'tile_' + cell.id;
        if (cell.winner) tile.classList.add('winner');
        if (ct <= _this2.game.size) tile.classList.add('top');
        if (ct > _this2.game.size * (_this2.game.size - 1)) tile.classList.add('bottom');
        if (ct % _this2.game.size == 1) tile.classList.add('left');
        if (ct % _this2.game.size == 0) tile.classList.add('right');
        if (cell.owner != 'none') {
          var _el = document.createElement('div');
          _el.classList.add('piece');
          _el.classList.add(cell.owner);
          tile.append(_el);
        } else {
          var _el2 = document.createElement('div');
          _el2.classList.add('empty');
          tile.append(_el2);
        }
        boardElement.append(tile);
        ct++;
      });
    }

    // Add click events to the board
    // This is the functional function of Wuziqi
  }, {
    key: "addEvents",
    value: function addEvents(board) {
      var _this3 = this;
      this.setPlayerActive();
      if (!this.gameBrowserActive()) {
        return;
      }
      board.forEach(function (cell) {
        el = document.getElementById('tile_' + cell.id);
        // Only add click function to blank cells,
        if (cell.owner == 'none') {
          // Add CSS indications that the cell can be clicked.
          el.classList.add('active');

          // When the cell is clicked
          el.addEventListener('click', function (e) {
            // Set it's owner to the clicker.
            cell.owner = _this3.roles[_this3.game.player];
            // Check for round winner.
            var winner = _this3.findWinner(cell);
            _this3.drawBoard(_this3.game.board);

            // Do the Saito Game Queue stuff

            // No matter what, add a 'place' message (filo - thi will be executed first) to update the board for both players.
            // Set the message type, the board state, cell played, player.
            var mv = 'place\t' + _this3.serializeBoard(board) + '\t' + cell.id + '\t' + _this3.game.player;
            // Add this move to the stack
            _this3.addMove(mv);

            // And send on chain.
            _this3.endTurn();
          });
        }
      });
    }
  }, {
    key: "removeEvents",
    value: function removeEvents() {
      this.drawBoard(this.game.board);
      this.playerbox.setInactive();
    }
  }, {
    key: "onTimeOver",
    value: function onTimeOver() {
      this.removeEvents();
      this.moves = ["roundover\t".concat(3 - this.game.player)];
      this.endTurn();
    }

    //
    // Core Game Logic
    //
  }, {
    key: "handleGameLoop",
    value: function () {
      var _handleGameLoop = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this4 = this;
        var msg,
          cell,
          qe,
          mv,
          first_player,
          i,
          player,
          winner,
          _player,
          _winner,
          _args2 = arguments;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              msg = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : null; // The Game Loop hands us back moves from the end of the stack (the reverse order they were added)
              this.drawBoard(this.game.board);

              // Check we have a queue
              if (!(this.game.queue.length > 0)) {
                _context2.n = 11;
                break;
              }
              // Save before we start executing the game queue
              // this.saveGame(this.game.id);
              // Get the last move and split it on tabs.
              qe = this.game.queue.length - 1;
              mv = this.game.queue[qe].split('\t'); // Game over conditions
              if (!(mv[0] === 'gameover')) {
                _context2.n = 2;
                break;
              }
              // Remove this item from the queue.
              this.game.queue = [];
              this.stopClock();
              _context2.n = 1;
              return this.triggerGameOver(this.game.players[parseInt(mv[1]) - 1], "best of ".concat(this.game.options.best_of));
            case 1:
              return _context2.a(2, 0);
            case 2:
              if (!(mv[0] === 'clearboard')) {
                _context2.n = 3;
                break;
              }
              first_player = parseInt(mv[1]);
              this.generateBoard(this.game.options.board_size);
              this.drawBoard(this.game.board);
              // Remove this item from the queue.
              this.game.queue.splice(this.game.queue.length - 1, 1);
              this.game.target = first_player;
              console.log('Update target: ', this.game.target);
              this.playerbox.setActive(first_player);
              if (this.useClock == 1) {
                this.game.time.last_received = new Date().getTime();
                for (i = 0; i < this.game.clock.length; i++) {
                  this.game.clock[i].spent = 0;
                  this.clock.displayTime(this.game.clock[i].limit - this.game.clock[i].spent, i + 1);
                }
              }
              if (this.game.player == first_player) {
                this.addEvents(this.game.board);
                this.game.status = 'You go first';
                this.hud.updateStatus(this.game.status);
                this.hud.updateMenu([]);
                this.hud.updateCards([]);
              } else {
                this.startClock();
                this.game.status = "Waiting for <span class=\"playertitle\">".concat(this.roles[first_player], " (").concat(this.app.keychain.returnUsername(this.game.players[first_player - 1]), ")</span> to start");
                this.hud.updateStatus(this.game.status);
                this.hud.updateMenu([]);
                this.hud.updateCards([]);
              }
              return _context2.a(2, 0);
            case 3:
              if (!(mv[0] == 'draw')) {
                _context2.n = 4;
                break;
              }
              player = parseInt(mv[1]); // Initiate next round.
              // Add a continue button if player did not play the winning token, just draw the board (and remove events if they did not);
              if (player != this.game.player && this.game.player > 0) {
                this.addContinueButton("It's a draw -- no winner.");
              } else {
                this.game.status = "Draw! <span class=\"playertitle\">".concat(this.roles[3 - player], "</span> (").concat(this.app.keychain.returnUsername(this.game.players[2 - player]), ") will start");
                this.hud.updateStatus(this.game.status);
                this.hud.updateMenu([]);
                this.hud.updateCards([]);
              }
              // Remove this item from the queue.
              this.game.queue.splice(this.game.queue.length - 1, 1);
              return _context2.a(2, 1);
            case 4:
              if (!(mv[0] == 'roundover')) {
                _context2.n = 8;
                break;
              }
              winner = parseInt(mv[1]);
              this.game.target = this.returnNextPlayer(winner);
              if (!(!this.gameBrowserActive() && this.game.player === this.game.target)) {
                _context2.n = 5;
                break;
              }
              this.game.status = 'You lost the round';
              this.hud.updateStatus(this.game.status);
              this.hud.updateMenu([]);
              this.hud.updateCards([]);
              this.setPlayerActive();
              return _context2.a(2, 0);
            case 5:
              // Remove this item from the queue.
              this.game.queue.splice(this.game.queue.length - 1, 1);

              // Update my scores
              this.game.score[winner - 1]++;
              this.racetrack.advancePlayer(winner);
              this.racetrack.lock();

              // If this round win, wins the game - let the winner know.
              if (!(2 * this.game.score[winner - 1] > this.game.options.best_of)) {
                _context2.n = 6;
                break;
              }
              this.game.winner = winner;

              // Add a game over message to the stack.
              this.game.queue.push('gameover\t' + winner);
              return _context2.a(2, 1);
            case 6:
              this.stopClock();
              // Initiate next round.
              // Add a continue button if player did not play the winning token, just draw the board (and remove events if they did not);
              if (winner != this.game.player) {
                this.addContinueButton('You lost!');
              } else {
                this.game.status = "You win the round! <span class=\"playertitle\">".concat(this.roles[3 - winner], "</span> (").concat(this.app.keychain.returnUsername(this.game.players[2 - winner]), ") will start");
                this.hud.updateStatus(this.game.status);
                this.hud.updateMenu([]);
                this.hud.updateCards([]);
                this.drawBoard(this.game.board);
              }
            case 7:
              return _context2.a(2, 0);
            case 8:
              if (!(mv[0] == 'place')) {
                _context2.n = 11;
                break;
              }
              _player = parseInt(mv[3]); // Regenerate the game board object from the serialized version sent by the other player.
              // Even though the player who just placed has an accurate board, we rerun it in case of browser refresh
              this.boardFromString(mv[1]);
              // Grab the played cell
              cell = this.returnCellById(parseInt(mv[2]));

              // And check if it won the game (this will just update winners in data structure)
              _winner = this.findWinner(cell);
              if (this.game.player !== _player) {
                this.animatePlay(cell);
              }

              // If we have a winner
              if (!(_winner != 'no winner')) {
                _context2.n = 9;
                break;
              }
              // If not only add a 'round over' message to the stack.
              this.game.queue = ['roundover\t' + _player];
              return _context2.a(2, 1);
            case 9:
              if (this.canPlayTile()) {
                _context2.n = 10;
                break;
              }
              this.game.queue = ['draw\t' + _player];
              return _context2.a(2, 1);
            case 10:
              this.game.target = this.returnNextPlayer(_player);
              this.playerbox.setActive(this.game.target);

              // Remove this item from the queue.
              this.game.queue.splice(this.game.queue.length - 1, 1);
            case 11:
              if (this.game.player == this.game.target) {
                //Let player make their move
                this.addEvents(this.game.board);
                console.log('GBA: ', this.gameBrowserActive());
                console.log('cell: ', cell);
                if (this.gameBrowserActive() && cell) {
                  this.game.status = "Your move <span class=\"replay\">Replay Last</span>";
                  this.hud.updateStatus(this.game.status);
                  this.hud.updateMenu([]);
                  this.hud.updateCards([]);
                  document.querySelector('.replay').onclick = function (e) {
                    _this4.animatePlay(cell);
                  };
                } else {
                  this.game.status = 'Your move';
                  this.hud.updateStatus(this.game.status);
                  this.hud.updateMenu([]);
                  this.hud.updateCards([]);
                }
              } else {
                this.startClock();
                this.game.status = "Waiting on <span class='playertitle'>".concat(this.roles[3 - this.game.player], "</span> (").concat(this.app.keychain.returnUsername(this.game.players[2 - this.game.player]), ")");
                this.hud.updateStatus(this.game.status);
                this.hud.updateMenu([]);
                this.hud.updateCards([]);
              }
              return _context2.a(2, 0);
          }
        }, _callee2, this);
      }));
      function handleGameLoop() {
        return _handleGameLoop.apply(this, arguments);
      }
      return handleGameLoop;
    }() // Add button to continue the game
  }, {
    key: "addContinueButton",
    value: function addContinueButton(notice) {
      if (this.game.player == 0) {
        return;
      }
      var game_self = this;
      this.playerAcknowledgeNotice(notice, function () {
        game_self.addMove('clearboard\t' + game_self.game.player);
        game_self.endTurn();
      });
    }

    // Check if a player won the round
  }, {
    key: "findWinner",
    value: function findWinner(cell) {
      var _this5 = this;
      var win;
      var winner = 'no winner';
      // Iterate through the row, column and diagonals for the played cell
      var _loop = function _loop() {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i3], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];
        // Test each to check if there are five cells in a row with the same colour tile.
        var testset = _this5.returnCellsInLine(key, value);
        win = 0; //reset to 0 when switch directions, just in case there is a possibility that we accidentally count a bent line
        // Only check if there are at least 5 cells in the line (diagonals can be short)
        if (testset.length > 4) {
          testset.forEach(function (item) {
            if (item.owner == cell.owner) {
              win = win + 1;
              if (win > 4) {
                _this5.showWin(key, value, cell);
                winner = cell.owner;
              }
            } else {
              win = 0;
            }
          });
        }
      };
      for (var _i3 = 0, _Object$entries = Object.entries(cell.sets); _i3 < _Object$entries.length; _i3++) {
        _loop();
      }
      return winner;
    }

    // Modify property winner of cells in the winning set so that CSS can be updated
  }, {
    key: "showWin",
    value: function showWin(key, value, cell) {
      var set = this.returnCellsInLine(key, value);
      this.markWinners(set, cell);
      //must run through both ways to mark the whole winning set
      set.reverse();
      this.markWinners(set, cell);
    }

    /*Skim through the line and start marking winning cells when we reach the given cell
      and as long as the following cells have the same owner */
  }, {
    key: "markWinners",
    value: function markWinners(set, cell) {
      var draw = false;
      set.forEach(function (el) {
        if (el.id == cell.id) {
          draw = true;
        }
        if (draw) {
          if (el.owner == cell.owner) {
            el.winner = true;
          } else {
            draw = false;
          }
        }
      });
    }

    /* Return cells that belong to a particular axis (horizontal, vertical, or diagonal)
          type = {row, col, lddiag, rudiag}
      */
  }, {
    key: "returnCellsInLine",
    value: function returnCellsInLine(type, value) {
      var cells = [];
      this.game.board.forEach(function (cell) {
        if (cell.sets[type] == value) {
          cells.push(cell);
        }
      });
      return cells;
    }
  }, {
    key: "returnCellById",
    value: function returnCellById(id) {
      var cell = {};
      this.game.board.forEach(function (item) {
        if (item.id == id) {
          cell = item;
        }
      });
      return cell;
    }
  }, {
    key: "canPlayTile",
    value: function canPlayTile() {
      var _iterator = _createForOfIteratorHelper(this.game.board),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          if (item.owner == 'none') {
            return true;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return false;
    }

    /*
      The following four function compress/decompress the board state into a string so that
      players can transmit it with their move, a completely unnecessary action, since each player places a single 
      tile at a time, it is enough to infer the new boardstate from the player's number and the cell id.
      */

    // Return the board as a series of letters B, W, N
    // For Black, White, No owner.
  }, {
    key: "serializeBoard",
    value: function serializeBoard(board) {
      var _this6 = this;
      boardString = '';
      board.forEach(function (cell) {
        boardString += _this6.shortOwner(cell.owner);
      });
      return boardString;
    }

    // Return a game board object from a serialised string.
  }, {
    key: "boardFromString",
    value: function boardFromString(boardString) {
      var _this7 = this;
      this.generateBoard(Math.sqrt(boardString.length));
      this.game.board.forEach(function (cell, idx) {
        cell.owner = _this7.longOwner(boardString[idx]);
      });
    }

    // Translators between B - black etc.
  }, {
    key: "shortOwner",
    value: function shortOwner(s) {
      switch (s) {
        case 'black':
          return 'B';
          break;
        case 'white':
          return 'W';
          break;
        default:
          return 'N';
          break;
      }
    }
  }, {
    key: "longOwner",
    value: function longOwner(s) {
      switch (s) {
        case 'B':
          return 'black';
          break;
        case 'W':
          return 'white';
          break;
        default:
          return 'none';
          break;
      }
    }
  }, {
    key: "returnSingularGameOption",
    value: function returnSingularGameOption() {
      return WuziqiSingularGameOptionsTemplate(this.app, this);
    }
    // Add options to the game start wizard for different game parameters
  }, {
    key: "returnAdvancedOptions",
    value: function returnAdvancedOptions() {
      return WuziqiGameOptionsTemplate(this.app, this);
    }
  }]);
}(GameTemplate);
module.exports = Wuziqi;